<template>
    <div>
      <Loader :active="loading" mensaje="Obteniendo información de asistencias" />
        <v-card>
            <v-card-text class="text-center">
              <h2>
                Hora {{ horaActual | time }}
              </h2>
              <p class="mt-3">
                Bienvenido/a  <span class="text-uppercase" >{{ dataUsuario.usuario }}</span>
              </p>
              <p>
                Versión {{ version }}
              </p>
            </v-card-text>
        </v-card>

        <Camara :idAsistencia="asistencias.idAsistencia" @entrada="getAsistencias" v-if="!loading" :operacion="getOperacion"/>
    </div>
</template>
<script>
import moment from 'moment'

// Components
import Camara from '../components/Camara'
import Loader from '../components/Loader'

// Services
import { session } from '../services/session'
import { asistencias } from '../services/asistencias'

export default {
  name: 'Asistencias',
  components: {
    Camara,
    Loader
  },
  data () {
    return {
      horaActual: new Date(),
      dataUsuario: {
        usuario: '',
        poligono: '',
        idUsuario: ''
      },
      asistencias: {
        entrada: null,
        error: false,
        idAsistencia: null,
        salida: null
      },
      version: process.env.VUE_APP_APP_VERSION,
      loading: true
    }
  },
  methods: {
    async getAsistencias () {
      const { idUsuario } = this.dataUsuario

      try {
        const { data } = await asistencias.io(idUsuario)

        if (data.error) throw Error(data.error)

        const { entrada, id_asistencia: idAsistencia, salida } = data

        this.asistencias = {
          ...this.asistencias,
          entrada,
          idAsistencia: idAsistencia,
          salida
        }
      } catch (error) {
        this.$toasted.show(error.message, {
          type: 'error',
          theme: 'bubble',
          position: 'bottom-center'
        })
      } finally {
        this.loading = false
      }
    },
    getSession () {
      const dataUsuario = session.getData()

      this.dataUsuario = { ...dataUsuario }
    },
    initTime () {
      setInterval(() => {
        this.horaActual = new Date()
      }, 1000)
    }
  },
  computed: {
    getOperacion () {
      if (this.asistencias.entrada === null) {
        return 'Entrada'
      } else if (this.asistencias.salida === null) {
        return 'Salida'
      } else {
        return 'completo'
      }
    }
  },
  mounted () {
    this.initTime()
    this.getSession()
    this.getAsistencias()
  },
  filters: {
    time (value) {
      return moment(value).format('LTS')
    }
  }
}
</script>
